import * as Sentry from "@sentry/nextjs";
import LandingPage from "components/LandingPage";
import { setCachingHeader } from "helpers/cacheHeader";
import { GetServerSideProps } from "next";
import { FC } from "react";
import { createDatoClient } from "services/datocms";
import {
  ComponentsWrapperFragment,
  LandingPageBySlugQuery,
  getSdk,
} from "services/datocms/generated";
import { createQueryParamsForCaching } from "utils/create-query-params";

type PromotionLandingPageProps = {
  landingPage?: LandingPageBySlugQuery["landingPage"];
  components?: ComponentsWrapperFragment | null;
};

export const getServerSideProps: GetServerSideProps<
  PromotionLandingPageProps
> = async (context) => {
  setCachingHeader(context);
  // setting this to the same name as the directory
  // TODO: still need to talk through multi-tenant aspect
  // of next routing (and translating routes)
  const slug = "promocja";

  try {
    // We launch all promises in parallel, and then first await for landingPage, and then for everything else
    const landingPagePromise = getSdk(
      createDatoClient(
        context.preview,
        createQueryParamsForCaching({
          queryType: "LandingPageBySlug",
          queryVariables: { slug },
        }),
      ),
    ).LandingPageBySlug({
      slug: `${slug}`,
    });

    const { landingPage } = await landingPagePromise;

    if (landingPage) {
      return {
        props: {
          landingPage,
        },
      };
    } else {
      return { notFound: true };
    }
  } catch (error) {
    Sentry.captureException(error);
    return {
      notFound: true,
    };
  }
};

const PromotionLandingPage: FC<PromotionLandingPageProps> = ({
  landingPage,
  components,
}) => {
  if (landingPage) {
    return <LandingPage landingPage={landingPage} />;
  }
};

export default PromotionLandingPage;
